<label>{{this.labelName}}</label>
<select *ngIf="this.displayOperatorSelector" class="selector" [(ngModel)]="this.selectedOperator"
  (change)="this.tryEmission()">
  <option></option>
  <option *ngFor="let operator of this.operators">{{operator}}</option>
</select>
<app-autocompleted-selector #autocompletedSelector (filterEmission)="emitFilterString($event)" class="selector"
  [isUnique]="this.isUnique" [selector]="this.selector" labelName="{{this.labelName}}" keychar="{{this.keychar}}"
  [selection]="this.selection"></app-autocompleted-selector>
